import { Link } from "react-router-dom";

const stats = [
  { value: "500+", label: "收录作品" },
  { value: "320万", label: "活跃读者" },
  { value: "40+", label: "分类标签" },
  { value: "1200+", label: "专题文章" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20illustration%20of%20a%20dreamy%20old%20town%20street%20lined%20with%20blooming%20sakura%20trees%2C%20floating%20cherry%20blossom%20petals%20drifting%20in%20warm%20dusk%20light%2C%20paper%20lanterns%20glowing%20soft%20orange%2C%20a%20lone%20reader%20sitting%20under%20a%20tree%20with%20an%20open%20manga%2C%20soft%20coral%20pink%20and%20warm%20amber%20palette%2C%20gentle%20mood%2C%20artistic%20anime%20landscape%2C%20rich%20texture%2C%20wide%20composition&width=1600&height=900&seq=hero-sakura&orientation=landscape"
        alt="樱花飘落的漫画小镇"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>

      <div className="relative z-10 w-full px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-black/25 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur-sm">
          <i className="ri-flower-line" aria-hidden="true"></i>
          国产漫画推荐与资讯门户
        </span>
        <h1 className="mt-6 font-heading text-3xl font-black leading-snug text-background-50 md:text-5xl md:leading-snug">
          在樱花盛开的季节
          <br />
          遇见值得追的漫画
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          聚合热门漫画排行、作品分类、新作连载动态与深度专题文章。
          从热血冒险到治愈日常，帮你快速找到属于自己的那部作品。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/manga"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            探索漫画库
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
          <Link
            to="/news"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/60 bg-white/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto"
          >
            阅读最新资讯
          </Link>
        </div>

        <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-xl border border-background-50/25 bg-black/20 px-4 py-4 backdrop-blur-sm"
            >
              <dt className="order-2 mt-1 block text-xs text-background-100/85">{s.label}</dt>
              <dd className="order-1 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {s.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}